module.exports = __webpack_public_path__ + "media/melodiait.dab96fd0.mp4";